import React, {useState} from 'react'
import Logo from '../assets/logo.png'
import { LogoutIcon, ViewGridIcon, CollectionIcon, LightBulbIcon, UserGroupIcon } from '@heroicons/react/outline'
import { NavLink } from 'react-router-dom'
import LogoutModal from './LogoutModal'

const Sidebar = () => {
  const menus = [
    {
      icon: ViewGridIcon,
      label: "Dasbor",
      route: "/"
    },
    {
      icon: CollectionIcon,
      label: "Konten",
      route: "/contents"
    },
    {
      icon: LightBulbIcon,
      label: "Kuis",
      route: "/quizzes"
    },
    {
      icon: UserGroupIcon,
      label: "Pengguna",
      route: "/users"
    },
    // {
    //   icon: CogIcon,
    //   label: "Atur",
    //   route: "/settings"
    // },
  ];

  const [showLogoutModal, setShowLogoutModal] = useState(false);

    const clickLogout = () => {
        setShowLogoutModal(true);
    }

    const closeModal = () => {
        setShowLogoutModal(false);
    }

  return (
    <div className="fixed h-screen p-5 bg-white shadow-md">
      <div className="flex flex-col items-center justify-between h-full">
        <img src={Logo} alt="Logo Hi Nano" className="w-16" />
        <div className='flex flex-col gap-6'>
          {
            menus.map((menu, index) => (
              <NavLink
                to={menu.route}
                key={index}
                className={({isActive}) => "flex flex-col items-center gap-1 p-2 rounded-md cursor-pointer hover:bg-slate-50"+ (isActive ? " text-amber-400" : "")}
              >
                <menu.icon className='w-6 h-6' />
                <span className="text-xs font-semibold">{menu.label}</span>
              </NavLink>
            ))
          }
        </div>
        <div onClick={clickLogout} className="flex flex-col items-center gap-1 p-2 text-red-500 rounded-md cursor-pointer hover:bg-slate-50">
          <LogoutIcon className='w-6 h-6' />
          <span className="text-xs font-semibold">Keluar</span>
        </div>
      </div>
      {
                showLogoutModal ? (
                <LogoutModal closeModal={closeModal}/>
                ) : ("")
            }
    </div>
  )
}

export default Sidebar